module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.pageLoading),
      expression: "pageLoading"
    }]
  }, [(_vm.currentApp) ? _c('el-row', {
    staticClass: "content-top"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('pages.hamlet_users.select_app')) + "\n    "), _c('el-select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.currentApp),
      callback: function($$v) {
        _vm.currentApp = $$v
      },
      expression: "currentApp"
    }
  }, _vm._l((_vm.apps), function(app) {
    return _c('el-option', {
      key: app.name,
      attrs: {
        "label": app.name,
        "value": app
      }
    }, [_vm._v("\n        " + _vm._s(app.name) + "\n      ")])
  }), 1), _vm._v(" "), (_vm.currentApp.allow_create_user) ? _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.toCreateUser
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("\n      " + _vm._s(_vm.$t('pages.hamlet_users.add_user')) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('el-row', {
    staticClass: "page-toolbar__group--right"
  }, [_c('el-input', {
    attrs: {
      "icon": "search",
      "placeholder": _vm.$t('pages.hamlet_users.searchPlaceholder')
    },
    model: {
      value: (_vm.tableCfg.search),
      callback: function($$v) {
        _vm.$set(_vm.tableCfg, "search", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "tableCfg.search"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-table', {
    attrs: {
      "data": _vm.currentUsers,
      "default-sort": {
        prop: 'id',
        order: 'ascending'
      }
    },
    on: {
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "width": "100",
      "sortable": "custom",
      "label": _vm.$t('pages.hamlet_users.id')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "width": "130",
      "sortable": "custom",
      "label": _vm.$t('pages.hamlet_users.username')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "min-width": "150",
      "sortable": "custom",
      "label": _vm.$t('pages.hamlet_users.email')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "role",
      "width": "100",
      "label": _vm.$t('pages.hamlet_users.role')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "last_login_at",
      "width": "160",
      "align": "center",
      "label": _vm.$t('pages.hamlet_users.last_login_at'),
      "formatter": _vm.formatDatetime
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "width": "120",
      "align": "center",
      "label": _vm.$t('pages.hamlet_users.status')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.status) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "thirdparty_users",
      "min-width": "100",
      "label": _vm.$t('pages.hamlet_users.thirdparty_users')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((Object.keys(scope.row.thirdparty_users)), function(type) {
          return _c('div', {
            key: type
          }, [_c('el-popover', {
            attrs: {
              "placement": "right",
              "trigger": "click"
            }
          }, [_c('el-button', {
            key: type,
            attrs: {
              "slot": "reference",
              "type": "text"
            },
            slot: "reference"
          }, [_vm._v("\n                " + _vm._s(_vm.$t(("common." + type))) + "\n              ")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(scope.row.thirdparty_users[type]))])], 1), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.toUnbindUserAccount(scope.row, type)
              }
            }
          }, [_vm._v("解绑")])], 1)
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "100",
      "align": "center",
      "label": _vm.$t('common.operation')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.resetPassword(scope.row)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t('common.resetPassword')) + "\n          ")]), _vm._v(" "), (scope.row.is_active) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.popUpEditUserDialog(scope.row)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t('common.edit')) + "\n          ")]) : _vm._e(), _vm._v(" "), (scope.row.is_active) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.activeUser(scope.row)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t('common.forbid')) + "\n          ")]) : _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.activeUser(scope.row)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t('common.active')) + "\n          ")]), _vm._v(" "), (scope.row.is_locked && scope.row.is_active) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.unlockUser(scope.row)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t('common.unlock')) + "\n          ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticClass: "table-wrapper__pagination",
    attrs: {
      "layout": "sizes, total, prev, pager, next",
      "page-sizes": _vm.tableCfg.pageSizes,
      "total": _vm.usersTotal
    },
    on: {
      "current-change": _vm.handleUsersCurPageChange,
      "size-change": _vm.handleUsersSizeChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('common.edit')
    },
    model: {
      value: (_vm.editDialog),
      callback: function($$v) {
        _vm.editDialog = $$v
      },
      expression: "editDialog"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.editUserForm,
      "label-width": "140px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('pages.hamlet_users.username')
    }
  }, [_vm._v("\n        " + _vm._s(_vm.editUserForm.username) + "\n      ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pages.hamlet_users.email'),
      "prop": "email"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.editUserForm.email) + "\n      ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pages.hamlet_users.role')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editUserForm.role),
      callback: function($$v) {
        _vm.$set(_vm.editUserForm, "role", $$v)
      },
      expression: "editUserForm.role"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pages.hamlet_users.tel')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editUserForm.tel),
      callback: function($$v) {
        _vm.$set(_vm.editUserForm, "tel", $$v)
      },
      expression: "editUserForm.tel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pages.hamlet_users.forceLoginSms')
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": _vm.$t('common.yes')
    },
    model: {
      value: (_vm.editUserForm.force_sms),
      callback: function($$v) {
        _vm.$set(_vm.editUserForm, "force_sms", $$v)
      },
      expression: "editUserForm.force_sms"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitEditUser
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('common.save')) + "\n        ")])], 1)], 1)], 1), _vm._v(" "), (_vm.currentApp && _vm.currentApp.allow_create_user) ? _c('el-dialog', {
    attrs: {
      "title": _vm.$t('pages.hamlet_users.add_user')
    },
    on: {
      "close": _vm.resetAdd
    },
    model: {
      value: (_vm.add),
      callback: function($$v) {
        _vm.add = $$v
      },
      expression: "add"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addUser,
      "rules": _vm.addUserRules,
      "label-width": "140px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('pages.hamlet_users.app_name')
    }
  }, [_vm._v("\n        " + _vm._s(_vm.currentApp.name) + "\n      ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.username'),
      "prop": "username"
    }
  }, [_c('el-input', {
    on: {
      "blur": _vm.checkUsername
    },
    model: {
      value: (_vm.addUser.username),
      callback: function($$v) {
        _vm.$set(_vm.addUser, "username", $$v)
      },
      expression: "addUser.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.email'),
      "prop": "email"
    }
  }, [_c('el-input', {
    on: {
      "blur": _vm.checkEmail
    },
    model: {
      value: (_vm.addUser.email),
      callback: function($$v) {
        _vm.$set(_vm.addUser, "email", $$v)
      },
      expression: "addUser.email"
    }
  })], 1), _vm._v(" "), (!_vm.usernameIsExist && !_vm.emailIsExist) ? [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.role'),
      "prop": "role"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addUser.role),
      callback: function($$v) {
        _vm.$set(_vm.addUser, "role", $$v)
      },
      expression: "addUser.role"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.password'),
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.addUser.password),
      callback: function($$v) {
        _vm.$set(_vm.addUser, "password", $$v)
      },
      expression: "addUser.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "random-psw"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.createRandomPassword()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('common.random_password')) + "\n          ")]), _vm._v(" "), _c('code', [_vm._v(_vm._s(this.randomPassword))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.confirmPassword'),
      "prop": "confirm_password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitAddUser($event)
      }
    },
    model: {
      value: (_vm.addUser.confirm_password),
      callback: function($$v) {
        _vm.$set(_vm.addUser, "confirm_password", $$v)
      },
      expression: "addUser.confirm_password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pages.hamlet_users.tel')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.addUser.tel),
      callback: function($$v) {
        _vm.$set(_vm.addUser, "tel", $$v)
      },
      expression: "addUser.tel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pages.hamlet_users.forceLoginSms')
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": _vm.$t('common.yes')
    },
    model: {
      value: (_vm.addUser.force_sms),
      callback: function($$v) {
        _vm.$set(_vm.addUser, "force_sms", $$v)
      },
      expression: "addUser.force_sms"
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "disabled": !this.addUser.username && !this.addUser.email,
      "type": "primary"
    },
    on: {
      "click": _vm.submitAddUser
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('common.save')) + "\n        ")])], 1)], 2)], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-resetpsw",
    attrs: {
      "title": _vm.$t('common.resetPassword')
    },
    on: {
      "close": _vm.clearResetform
    },
    model: {
      value: (_vm.reset),
      callback: function($$v) {
        _vm.reset = $$v
      },
      expression: "reset"
    }
  }, [_c('el-form', {
    ref: "resetForm",
    attrs: {
      "model": _vm.userReset,
      "rules": _vm.resetPasswordRules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.username'),
      "prop": "username"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.userReset.username) + "\n      ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.password'),
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.userReset.password),
      callback: function($$v) {
        _vm.$set(_vm.userReset, "password", $$v)
      },
      expression: "userReset.password"
    }
  }), _vm._v(" "), _c('el-row', {
    staticClass: "random-psw"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.createRandomPassword()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('common.random_password')) + "\n          ")]), _vm._v(" "), _c('code', [_vm._v(_vm._s(this.randomPassword))])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.confirmPassword'),
      "prop": "confirm_password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitResetPassword($event)
      }
    },
    model: {
      value: (_vm.userReset.confirm_password),
      callback: function($$v) {
        _vm.$set(_vm.userReset, "confirm_password", $$v)
      },
      expression: "userReset.confirm_password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitResetPassword
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('common.save')) + "\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-031b59ad"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AppUsers.vue
// module id = 383
// module chunks = 1